import { createAction, props, Action } from '@ngrx/store';
import { ApiError, BasketItem, Basket } from '../client/src';
import { BookingSummary } from '@nx-ng/types';
import { CreateBasketItem } from '../types';

export const LOAD_BASKET_TYPE = '[Checkout] Load Basket API';
export const checkoutAPI_loadBasket = createAction(
  LOAD_BASKET_TYPE,
  props<{ basketId: string }>()
);

export const checkoutAPI_loadBasketSuccess = createAction(
  `${LOAD_BASKET_TYPE} Success`,
  props<{ basket: Basket }>()
);

export const checkoutAPI_loadBasketFailure = createAction(
  `${LOAD_BASKET_TYPE} Failure`,
  props<{ error?: string | ApiError; retryAction?: Action }>()
);

export const checkoutAPI_updateBasketSuccess = createAction(
  '[Checkout] Update Basket API Success',
  props<{ basket: Basket }>()
);

export const checkoutAPI_removeBasketSuccess = createAction(
  '[Checkout] Remove Basket API Success'
);

export const checkoutAPI_updateBasketFailure = createAction(
  '[Checkout] Update Basket API Failure',
  props<{ error?: string | ApiError; retryAction?: Action }>()
);

export const UPDATE_BASKET_TYPE = '[Checkout] Update Item Quantity';
export const updateBasketItemQuantity = createAction(
  UPDATE_BASKET_TYPE,
  props<{
    item: Pick<BasketItem, 'quantity' | 'ticketID'>;
    showBasketOnSuccess?: boolean;
  }>()
);

export const convertItemToSubscription = createAction(
  '[Checkout] Convert Basket Items to subscription',
  props<{
    item: Pick<BasketItem, 'quantity' | 'ticketID'>;
  }>()
);

export const addTicketToBasketUsingAlias = createAction(
  '[Checkout] Recreate basket from ticket Alias',
  props<{
    ticketAlias: string;
    basketId?: string;
  }>()
);

export const fetchTicketDescriptionsForBasketItems = createAction(
  '[Checkout] Fetch ticket descriptions for basket items',
  props<{
    tickets: number[];
  }>()
);

export const findTicketAndAddToBasket = createAction(
  '[Checkout] Find Ticket and add to basket',
  props<{ ticket: Pick<BasketItem, 'quantity' | 'ticketID'> }>()
);

export const recreateBasketFromsAliasFailure = createAction(
  '[Checkout] Recreate basket from ticket Alias failure'
);

export const recreateBasketFromsAliasSuccess = createAction(
  '[Checkout] Recreate basket from ticket Alias success'
);

export const addMultipleItemsToBasket = createAction(
  '[Checkout] Add multiple items to basket',
  props<{
    ticketQueue?: Pick<
      BasketItem,
      'ticketID' | 'quantity' | 'paymentMethodType'
    >[];
  }>()
);

export const addMultipleItemsToBasketSuccess = createAction(
  '[Checkout] Add multiple items to basket Success'
);

export const addMultipleItemsToBasketFailure = createAction(
  '[Checkout] Add multiple items to basket Failure',
  props<{ error?: string | ApiError }>()
);

export const notifyBasketIsFull = createAction(
  '[Checkout] Notify basket is full'
);

export const saveBookingSummary = createAction(
  '[Checkout] Save Booking Summary',
  props<{ bookingSummary?: BookingSummary }>()
);

export const sendBasketEventToGtm = createAction(
  '[Checkout] Send Basket event to Gtm',
  props<{ basketPriorToEvent?: Basket; basketItem: CreateBasketItem }>()
);
